import { Footer } from './footer'
// import { Nav } from './nav'
export const Wrap = ({
  children,
  className
}: {
  children: React.ReactNode
  className?: string
}) => {
  const classNameArr = ['wrapper']
  if (className) {
    classNameArr.push(className)
  }
  return (
    <>
      <div className={classNameArr.join(' ')}>
        {/* <Nav /> */}
        {children}
      </div>
      <Footer />
    </>
  )
}
